import { gql } from 'apollo-angular';

export const CreateContentGenerationImageDocument =
  gql(/* GraphQL*/ `mutation createContentGenerationImage($funnelId: Int!, $file: Upload!) {
  createContentGenerationImage(funnelId: $funnelId, file: $file) {
    id
  }
}
`);
